import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorSettingScope,
  CollectorSettingsInput,
  CollectorSettingsUnifiedQuery,
  Exact,
  Maybe,
  useCollectorSettingsUnifiedQuery
} from 'graphql/types';
import { useMeContext } from 'modules/me/MeContextProvider';

export const useCollectorSettingsUnified = (): {
  data: CollectorSettingsUnifiedQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?:
      | Partial<
          Exact<{
            input?: Maybe<CollectorSettingsInput>;
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<CollectorSettingsUnifiedQuery>>;
} => {
  const me = useMeContext();
  const isAdmin = useMemo(() => {
    return me?.permissions?.hasCompanyCollectorInstallAccess ? true : false;
  }, [me]);
  const { loading, data, error, refetch } = useCollectorSettingsUnifiedQuery({
    variables: {
      input: {
        filterByScope: isAdmin ? null : CollectorSettingScope.User
      }
    }
  });

  return useMemo(
    () => ({
      loading,
      error,
      data,
      refetch
    }),
    [data, error, loading, refetch]
  );
};
